import loadable from '@loadable/component';

import { CmsApiStickyHeaderLinksGradBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksGradBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsStickyHeaderLinksGradBlockMapping: CmsBlockMapping<CmsApiStickyHeaderLinksGradBlockData> =
  {
    invariant: [
      {
        prop: 'links',
        msg: 'Links required for sticky header links',
      },
    ],
    width: CmsMappedBlockWidth.FULL,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsStickyHeaderLinksGradBlock'), {
        resolveComponent: (module) => module.CmsStickyHeaderLinksGradBlock,
      }),
    ),
    AmpComponent: loadable(() => import('./CmsAmpStickyHeaderLinksGradBlock'), {
      resolveComponent: (module) => module.CmsAmpStickyHeaderLinksGradBlock,
    }),
  };
